export default process.env.NODE_ENV === "development"
	? "http://localhost:3002"
	: "https://api.solbook.io";
